:host {
  @apply ms-0.5 me-0.5 my-1;
}
:host > a,
:host > button {
  @apply flex w-fit justify-center items-center shrink-0 rounded px-4 py-2 text-center text-base not-italic font-semibold leading-8 tracking-[0.16px];
}
:host(.button-block) {
  @apply block;
}
:host(.button-block) .button-native {
  @apply mx-0 w-full clear-both;

  contain: content;
}

:host(.button-disabled) > a,
:host(.button-disabled) > button {
  pointer-events: none;
  cursor: not-allowed;
  &.accent {
    @apply opacity-30 text-opacity-30;
  }

  &.primary {
    @apply opacity-60 text-opacity-60;
  }
  &.clear {
    @apply text-opacity-80;
  }
}
:host(.accent) > a,
:host(.accent) > button {
  @apply bg-accent text-on-accent;
  * {
    @apply text-on-accent;
  }
  &:active {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%), var(--accent);
  }
}

:host(.primary) > a,
:host(.primary) > button {
  @apply bg-primary text-on;
  * {
    @apply text-on;
  }
  &:active {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1) 100%), var(--primary);
  }
}

:host(.outline) > a,
:host(.outline) > button {
  outline-width: 2px;
  @apply text-on;
}

:host(.button-clear) > a,
:host(.button-clear) > button {
  @apply bg-transparent;
  * {
    color: inherit;
  }
  &:active {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.681) 0%, rgba(255, 255, 255, 0.799) 100%), var(--surface);
    @apply backdrop-blur-lg
  }
  &.primary {
    @apply text-primary;
  }

  &.accent {
    @apply text-accent;
  }
}

.button-inner {
  @apply flex flex-row flex-shrink-0 items-center w-full h-full z-10;
}

::slotted([slot='start']),
::slotted([slot='end']) {
  @apply shrink-0;
}

::slotted([slot='start']) {
  // @include margin(0, .3em, 0, -.3em);
  @apply mr-1 -ml-1 my-0;
}

::slotted([slot='end']) {
  // @include margin(0, -.2em, 0, .3em);
  @apply ml-1 -mr-1 my-0;
}

::slotted([slot='icon-only']) {
  // font-size: 1.8em;
  @apply text-2xl;
}

:host(.button-large) > button,
:host(.button-large) > a {
  @apply px-5 py-4 text-lg min-h-7;
}

:host(.button-small) > button,
:host(.button-small) > a {
  @apply px-2 py-1 text-sm min-h-2;
}

:host(.button-has-icon-only) > button,
:host(.button-has-icon-only) > a {
  @apply px-3;
}
